import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./ModeConfigPricingReportSummary.module.css";

const ModeConfigPricingReportSummary = ({
  refreshData = () => {},
  refreshRef,
  quickExport = () => {},
  exportRef,
  rackHandler = () => {},
  rackRef = () => {},
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              label="Quick Export"
              color="black"
              endIcon={<Shortcut keys={["Alt", "E"]} />}
              onClick={quickExport}
              isAccessible={true}
              ref={exportRef}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              onClick={rackHandler}
              startIcon={<Shortcut keys={["Ctrl", "U"]} />}
              label="Set Details"
              ref={rackRef}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default ModeConfigPricingReportSummary;
